module.exports = __webpack_public_path__ + "static/media/ja.6d234df0.svg";